import './LoaderIcon.css'

const LoaderIcon = () => {
    return (
      <div className="loader">
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    );
}
 
export default LoaderIcon;